'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _detectBrowser = require('detect-browser');

var _types = require('./types');

var browser = (0, _detectBrowser.detect)();

var MarkdownRenderer = function MarkdownRenderer(_ref) {
  var children = _ref.children;
  return children({ browser: browser });
};

exports.default = MarkdownRenderer;